let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dSXly")).then(() => parcelRequire('2FA8A'));